import "./Dashboard.css";
import React, { Fragment, useState } from "react";
// import AdSense from "react-adsense";
import StudentIcon from "../../../Assets/images/icons/dash-icon-01.svg";
import TeacherIcon from "../../../Assets/images/icons/Teacher.png";
import ClassesIcon from "../../../Assets/images/icons/Classes.png";
import RevenueIcon from "../../../Assets/images/icons/dash-icon-04.svg";
import ProfileIcon from "../../../Assets/images/profiles/avatar-02.jpg";
import AwardIcon1 from "../../../Assets/images/icons/award-icon-01.svg";
import AwardIcon2 from "../../../Assets/images/icons/award-icon-02.svg";
import AwardIcon3 from "../../../Assets/images/icons/award-icon-03.svg";
import AwardIcon4 from "../../../Assets/images/icons/award-icon-04.svg";
import FaceBookIcon from "../../../Assets/images/icons/social-icon-01.svg";
import TwitterIcon from "../../../Assets/images/icons/social-icon-02.svg";
import InstaIcon from "../../../Assets/images/icons/social-icon-03.svg";
import LinkedinIcon from "../../../Assets/images/icons/social-icon-04.svg";

import Chart from "react-apexcharts";
import DashBoardViewModal from "./DashBoardViewModal";
const Dashboard = () => {
  const {
    ChartData,
    VerticalChart,
    TotalNoOFStudents,
    TotalNoOFTeachers,
    TotalNoOFClasses,
  } = DashBoardViewModal();
  return (
    <Fragment>
      {/* <AdSense.Google
        client="ca-pub-3482204163963721"
        slot="9775187121"
        style={{ width: 500, height: 300, float: "left" }}
        format="fluid"
      /> */}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <div className="page-sub-header">
                  <h3 className="page-title">Welcome Admin!</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="index.html">Home</a>
                    </li>
                    <li className="breadcrumb-item active">Admin</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="card bg-comman w-100">
                <div className="card-body">
                  <div className="db-widgets d-flex justify-content-between align-items-center">
                    <div className="db-info">
                      <h6>Students</h6>
                      <h3>{TotalNoOFStudents}</h3>
                    </div>
                    <div className="db-icon">
                      <img src={StudentIcon} alt="Dashboard Icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="card bg-comman w-100">
                <div className="card-body">
                  <div className="db-widgets d-flex justify-content-between align-items-center">
                    <div className="db-info">
                      <h6>Teachers</h6>
                      <h3>{TotalNoOFTeachers}</h3>
                    </div>
                    <div className="db-icon">
                      <img src={TeacherIcon} alt="Dashboard Icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="card bg-comman w-100">
                <div className="card-body">
                  <div className="db-widgets d-flex justify-content-between align-items-center">
                    <div className="db-info">
                      <h6>Classes</h6>
                      <h3>{TotalNoOFClasses}</h3>
                    </div>
                    <div className="db-icon">
                      <img alt="Dashboard Icon" src={ClassesIcon} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="card bg-comman w-100">
                <div className="card-body">
                  <div className="db-widgets d-flex justify-content-between align-items-center">
                    <div className="db-info">
                      <h6>Revenue</h6>
                      <h3>$505</h3>
                    </div>
                    <div className="db-icon">
                      <img src={RevenueIcon} alt="Dashboard Icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-lg-6">
              <div className="card card-chart">
                <div className="card-header">
                  <div className="row align-items-center">
                    <div className="col-6">
                      <h5 className="card-title">Overview</h5>
                    </div>
                    <div className="col-6">
                      <ul className="chart-list-out">
                        <li>
                          <span className="circle-blue"></span>Teacher
                        </li>
                        <li>
                          <span className="circle-green"></span>Student
                        </li>
                        <li className="star-menus">
                          <a href="javascript:;">
                            <i className="fas fa-ellipsis-v"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <Chart
                    options={ChartData.options}
                    series={ChartData.series}
                    type="line"
                    height={350}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-6">
              <div className="card card-chart">
                <div className="card-header">
                  <div className="row align-items-center">
                    <div className="col-6">
                      <h5 className="card-title">Number of Students</h5>
                    </div>
                    <div className="col-6">
                      <ul className="chart-list-out">
                        <li>
                          <span className="circle-blue"></span>Girls
                        </li>
                        <li>
                          <span className="circle-green"></span>Boys
                        </li>
                        <li className="star-menus">
                          <a href="javascript:;">
                            <i className="fas fa-ellipsis-v"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <Chart
                    options={VerticalChart.options}
                    series={VerticalChart.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </div>
            </div>
          </div>
          <Fragment>
            {/* <div className="row d-none">
              <div className="col-xl-6 d-flex">
                <div className="card flex-fill student-space comman-shadow">
                  <div className="card-header d-flex align-items-center">
                    <h5 className="card-title">Star Students</h5>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table star-student table-hover table-center table-borderless table-striped">
                        <thead className="thead-light">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th className="text-center">Marks</th>
                            <th className="text-center">Percentage</th>
                            <th className="text-end">Year</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-nowrap">
                              <div>PRE2209</div>
                            </td>
                            <td className="text-nowrap">
                              <img
                                className="rounded-circle"
                                src={ProfileIcon}
                                alt="Star Students"
                                width={25}
                              />
                              John Smith
                            </td>
                            <td className="text-center">1185</td>
                            <td className="text-center">98%</td>
                            <td className="text-end">
                              <div>2019</div>
                            </td>
                          </tr>
                          <tr>
                            <td className="text-nowrap">
                              <div>PRE1245</div>
                            </td>
                            <td className="text-nowrap">
                              <img
                                className="rounded-circle"
                                src={ProfileIcon}
                                alt="Star Students"
                                width={25}
                              />
                              Jolie Hoskins
                            </td>
                            <td className="text-center">1195</td>
                            <td className="text-center">99.5%</td>
                            <td className="text-end">
                              <div>2018</div>
                            </td>
                          </tr>
                          <tr>
                            <td className="text-nowrap">
                              <div>PRE1625</div>
                            </td>
                            <td className="text-nowrap">
                              <img
                                className="rounded-circle"
                                src={ProfileIcon}
                                alt="Star Students"
                                width={25}
                              />
                              Pennington Joy
                            </td>
                            <td className="text-center">1196</td>
                            <td className="text-center">99.6%</td>
                            <td className="text-end">
                              <div>2017</div>
                            </td>
                          </tr>
                          <tr>
                            <td className="text-nowrap">
                              <div>PRE2516</div>
                            </td>
                            <td className="text-nowrap">
                              <img
                                className="rounded-circle"
                                src={ProfileIcon}
                                alt="Star Students"
                                width={25}
                              />
                              Millie Marsden
                            </td>
                            <td className="text-center">1187</td>
                            <td className="text-center">98.2%</td>
                            <td className="text-end">
                              <div>2016</div>
                            </td>
                          </tr>
                          <tr>
                            <td className="text-nowrap">
                              <div>PRE2209</div>
                            </td>
                            <td className="text-nowrap">
                              <img
                                className="rounded-circle"
                                src={ProfileIcon}
                                alt="Star Students"
                                width={25}
                              />
                              John Smith
                            </td>
                            <td className="text-center">1185</td>
                            <td className="text-center">98%</td>
                            <td className="text-end">
                              <div>2015</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 d-flex">
                <div className="card flex-fill comman-shadow">
                  <div className="card-header d-flex align-items-center">
                    <h5 className="card-title ">Student Activity </h5>
                  </div>
                  <div className="card-body">
                    <div className="activity-groups">
                      <div className="activity-awards">
                        <div className="award-boxs">
                          <img src={AwardIcon1} alt="Award" />
                        </div>
                        <div className="award-list-outs">
                          <h4>1st place in "Chess”</h4>
                          <h5>John Doe won 1st place in "Chess"</h5>
                        </div>
                        <div className="award-time-list">
                          <span>1 Day ago</span>
                        </div>
                      </div>
                      <div className="activity-awards">
                        <div className="award-boxs">
                          <img src={AwardIcon2} alt="Award" />
                        </div>
                        <div className="award-list-outs">
                          <h4>Participated in "Carrom"</h4>
                          <h5>Justin Lee participated in "Carrom"</h5>
                        </div>
                        <div className="award-time-list">
                          <span>2 hours ago</span>
                        </div>
                      </div>
                      <div className="activity-awards">
                        <div className="award-boxs">
                          <img src={AwardIcon3} alt="Award" />
                        </div>
                        <div className="award-list-outs">
                          <h4>Internation conference in "St.John School"</h4>
                          <h5>
                            Justin Leeattended internation conference in
                            "St.John School"
                          </h5>
                        </div>
                        <div className="award-time-list">
                          <span>2 Week ago</span>
                        </div>
                      </div>
                      <div className="activity-awards mb-0">
                        <div className="award-boxs">
                          <img src={AwardIcon4} alt="Award" />
                        </div>
                        <div className="award-list-outs">
                          <h4>Won 1st place in "Chess"</h4>
                          <h5>John Doe won 1st place in "Chess"</h5>
                        </div>
                        <div className="award-time-list">
                          <span>3 Day ago</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </Fragment>
          <div>
            {/* Socail Media Follows */}
            <div className="row">
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card flex-fill fb sm-box">
                  <div className="social-likes">
                    <p>Like us on facebook</p>
                    <h6>50,095</h6>
                  </div>
                  <div className="social-boxs">
                    <img src={FaceBookIcon} alt="Social Icon" />
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card flex-fill twitter sm-box">
                  <div className="social-likes">
                    <p>Follow us on twitter</p>
                    <h6>48,596</h6>
                  </div>
                  <div className="social-boxs">
                    <img src={TwitterIcon} alt="Social Icon" />
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card flex-fill insta sm-box">
                  <div className="social-likes">
                    <p>Follow us on instagram</p>
                    <h6>52,085</h6>
                  </div>
                  <div className="social-boxs">
                    <img src={InstaIcon} alt="Social Icon" />
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card flex-fill linkedin sm-box">
                  <div className="social-likes">
                    <p>Follow us on linkedin</p>
                    <h6>69,050</h6>
                  </div>
                  <div className="social-boxs">
                    <img src={LinkedinIcon} alt="Social Icon" />
                  </div>
                </div>
              </div>
            </div>
            {/* /Socail Media Follows */}
            {/* Footer */}
            <footer>
              <p>Copyright © {new Date().getFullYear()} Logic Worms.</p>
            </footer>
            {/* /Footer */}
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default Dashboard;
